<template>
	<Layout>
		<div class="tabpage">
			<div class="mt80">
				<StaticBanner :banner-date="bannerDate"></StaticBanner>
			</div>
			<div class="titles">
				<div class="in_titles">
					<div class="in_titles_left">
						<img class="in_titles_left_img" src="../assets/images/industry/tb.png" alt="">
						<div><span style="margin-right: 10px;">&gt;</span><span style="font-size: 18px;">智能技术RPA</span>
						</div>
					</div>
					<div class="in_titles_right">
					</div>
				</div>
			</div>
			<div class="tabmainrpa">
				<div class="container tab-block">
					<div class='fs-1 fw-bold lyd-title-colo1 text-center mt100' data-aos="fade-up">智能技术RPA</div>
					<div class='tabmainrpacont text-center'>
						<div class="fs-4 text-center mt20" data-aos="fade-up">
							建立在云计算、物联网基础上，通过大数据技术进行建模与分析，结合RPA技术为企业提供智能化管理服务，通过对业务进行预测、控制、分析与决策一体化的应用，实现企业业财一体化深度融合管理。
						</div>
						<button type="button"
							class="btn-default btn-default-primary btn-small mt50 tabsbtnshado" @click="goRouter">立即咨询</button>
					</div>
					<div class="tabmainrpabg mt50 mb100  d-none d-lg-block" data-aos="fade-up">
					</div>
				</div>
			</div>
			<div class="rpa-jiqiren">
				<div class="container tab-block">
					<div class='fs-1 fw-bold text-center lyd-title-colo1' data-aos="fade-up">智能财务机器人的整体应用架构</div>
					<div class='fs-3 text-center lyd-title-colo1' data-aos="fade-up">AI+RPA融合、决策分析智能化、业务流程自动化</div>
					<div class="rpa-jiqiren-main d-none d-lg-block">
						<div style="display: flex;justify-content: space-between;">
							<div class="rpa-jiqiren-main-l">
								<div class="rpa-jiqiren-main-l-img1"></div>
								<div class="rpa-jiqiren-main-l-hx"></div>
							</div>
							<div class="rpa-jiqiren-main-r">
							</div>
							<div class="rpadm-top">
								<!-- <div class="labeltxt anim1">AI服务</div>
								<div class="labeltxt anim2">今天天气如何？</div>
								<div class="labeltxt anim3">路况拥堵状况</div>
								<div class="labeltxt anim4">今天推荐吃什么？</div> -->
								<div class="rpadm-cont-main">
									<vue-seamless-scroll :data="data1" :class-option="defaultOption1" >
										<div class="companymain">
											<div class="color1 labeltxtnot" v-for="(item,index) in data1">{{item}}</div>
										</div>
										
									</vue-seamless-scroll>
								</div>
							</div>
							<div class="rpadm-cen">
								<!-- <div class="rpadm-cen-main">
									<div class="labeltxt1 animcent1">我要开票</div>
									<div class="labeltxt1 animcent2">给我讲解下多核算体系</div>
									<div class="labeltxt1 animcent3">什么是智能申报？</div>
									<div class="labeltxt1 animcent4">我要对账</div>
									<div class="labeltxt1 animcent5">想了解下什么是智能对账</div>
								</div> -->
								<div class="rpadm-cont-main">
									<vue-seamless-scroll :data="data2" :class-option="defaultOption2" >
										<div class="companymain">
											<div class="color2 labeltxtnot" v-for="(item,index) in data2">{{item}}</div>
										</div>
										
									</vue-seamless-scroll>
								</div>
							</div>
							<div class="rpadm-bottom">
								<div class="rpadm-cont-main">
									<vue-seamless-scroll :data="data3" :class-option="defaultOption" >
										<div class="companymain">
											<div class="labeltxtnot" v-for="(item,index) in data3">{{item}}</div>
										</div>
										
									</vue-seamless-scroll>
								</div>
							</div>
							<div class="rpaliaot"></div>
							<div class="rpaxuexi"></div>
							<div class="rpagongzuo"></div>
							<div class="juxingbaiyy"></div>
						</div>
						
					</div>
					<div class="rpa-jiqiren-main d-block d-lg-none">
						<div class="rpa-jiqiren-main-mobile">
							<div class="rpa-jiqiren-main-l">
								<div class="rpa-jiqiren-main-mobile-jiqiricon"></div>
								<div class="rpa-jiqiren-main-mobile-zhx"></div>
							</div>
							
							<div class="rpa-jiqiren-main-r">
							</div>
							
							<div class="rpadm-top-m">
								<div class="rpadm-cont-main-m">
									<vue-seamless-scroll :data="data1" :class-option="defaultOption" >
										<div class="companymain">
											<div class="labeltxtnot1 color1" v-for="(item,index) in data1">{{item}}</div>
										</div>
										
									</vue-seamless-scroll>
								</div>
							</div>
							<div class="rpadm-cen-m">
								<div class="rpadm-cont-main-m">
									<vue-seamless-scroll :data="data2" :class-option="defaultOption" >
										<div class="companymain">
											<div class="labeltxtnot1 color2" v-for="(item,index) in data2">{{item}}</div>
										</div>
										
									</vue-seamless-scroll>
								</div>
							</div>
							<div class="rpadm-bottom-m">
								<div class="rpadm-cont-main-m rpadm-cont-main-m1">
									<vue-seamless-scroll :data="data3" :class-option="defaultOption" >
										<div class="companymain">
											<div class="labeltxtnot1 color3" v-for="(item,index) in data3">{{item}}</div>
										</div>
										
									</vue-seamless-scroll>
								</div>
							</div>
							<div class="rpa-m-liaot"></div>
							<div class="rpa-m-xuexi"></div>
							<div class="rpa-m-gongzuo"></div>
						</div>
					</div>
					<div class="rpabottom" data-aos="fade-up"></div>
					
				</div>
			</div>
			<div class="rpachangjing d-none d-lg-block">
				<div class="container tab-block">
					<div class='fs-1 fw-bold text-center text-white' data-aos="fade-up">智能财务机器人典型应用场景</div>
					<div class='fs-3 text-center text-white' data-aos="fade-up">AI+RPA融合、决策分析智能化、业务流程自动化</div>
					
					<div class="rpachangjingmain">
						<div class="rpachangjingmain-item" :class="[index%2==0?'':'mt20']" v-for="(item,index) in rpacjall" :key="index" @mouseenter="mouseenter(item,index)">
							<img :src="item.url" class="rpachangjingmain-item-img animate__animated" :class="item.anclass" alt="" srcset="">
							<div class="rpachangjingmain-item-title fs-5 text-center text-white animate__animated" :class="`${item.anclass2} widthtabsl${index}`">{{item.label1}}</div>
							<div class="rpachangjingmain-item-title fs-5 text-center text-white animate__animated" :class="item.anclass2" v-if='item.label2'>{{item.label2}}</div>
							<img class="rpachangjingmain-item-icon" :class="index%2==0?`routeindex${index}`:`patop routeindex${index}`" v-if="index != rpacjall.length-1" :src="item.icon" alt="">
						</div>
					</div>
					
				</div>
			</div>
			<div class="rpachangjing d-block d-lg-none">
				<div class="container tab-block">
					<div class='fs-1 fw-bold text-center text-white' data-aos="fade-up">智能财务机器人典型应用场景</div>
					<div class='fs-3 text-center text-white' data-aos="fade-up">AI+RPA融合、决策分析智能化、业务流程自动化</div>
					
					<div class="rpachangjingmain">
						<div class="rpachangjingmain-item" :class="[index%2==0?'':'']" v-for="(item,index) in rpacjallmoblie1" :key="index" @mouseenter="mouseenter(item,index)">
							<img :src="item.url" class="rpachangjingmain-item-img animate__animated" :class="item.anclass" alt="" srcset="">
							<div class="rpachangjingmain-item-title fs-5 text-center text-white animate__animated" :class="`${item.anclass2} widthtabsl${index}`">{{item.label1}}</div>
							<div class="rpachangjingmain-item-title fs-5 text-center text-white animate__animated" :class="item.anclass2" v-if='item.label2'>{{item.label2}}</div>
							<img class="rpachangjingmain-item-icon" :class="index%2==0?`routeindex${index}`:`patop routeindex${index}`" v-if="index != rpacjallmoblie1.length-1" :src="item.icon" alt="">
						</div>
					</div>
					<img class="rpachangjingmain-item-icon1  1233"  :src="rpacjall[0].icon" alt="">
					<div class="rpachangjingmain rpajiqitab2">
						<div class="rpachangjingmain-item" :class="[index%2==0?'':'']" v-for="(item,index) in rpacjallmoblie2" :key="index" @mouseenter="mouseenter(item,index)">
							<img :src="item.url" class="rpachangjingmain-item-img animate__animated" :class="item.anclass" alt="" srcset="">
							<div class="rpachangjingmain-item-title fs-5 text-center text-white animate__animated" :class="`${item.anclass2} widthtabsl${index}`">{{item.label1}}</div>
							<div class="rpachangjingmain-item-title fs-5 text-center text-white animate__animated" :class="item.anclass2" v-if='item.label2'>{{item.label2}}</div>
							<img class="rpachangjingmain-item-icon" :class="index%2==0?`routeindex${index}`:`patop routeindex${index}`" v-if="index != rpacjallmoblie2.length-1" :src="item.icon" alt="">
						</div>
					</div>
					
				</div>
			</div>
			
			
			
			<div class="rpaApplication">
				<div class="container tab-block mh300">
					<div class='fs-1 fw-bold text-center lyd-title-colo1' data-aos="fade-up">智能技术应用价值</div>
					<div class='fs-3 text-center lyd-title-colo1' data-aos="fade-up">人工VS机器人：1个机器人=（2-5）人工，机器人比人工在更短的时间内完成既定的工作。</div>
					<div class="rpaApplication-wrap">
						<div class="rpaApplication-main">
							<div class="rpaApplication-main-l">
								<div class="rpaApplication-main-l-item fw-bold">
									人工方式
								</div>
								<div class="rpaApplication-main-l-item" :class="{'activetxtindex1':i === activetxtindex}" v-for="(item,i) in cloums1" @mouseenter="mouseenteractive(i)" @mouseleave="mouseleaveactive">
									{{item}}
								</div>
							</div>
							<div class="rpaApplication-main-c">
								<div class="rpaApplication-main-l-item text-white fw-bold" style="margin-left: 20px;">
									核心工作指标
								</div>
								<div class="rpaApplication-main-l-item text-white" :class="{'activetxtindex2':j === activetxtindex}" v-for="(item,j) in cloums2" @mouseenter="mouseenteractive(j)" @mouseleave="mouseleaveactive">
									<img src="../assets/images/tab/rpasure.png" style="margin-right: 10px;" alt="">
									{{item}}
								</div>
							</div>
							<div class="rpaApplication-main-r">
								<div class="rpaApplication-main-l-item fw-bold">
									机器人模式
								</div>
								<div class="rpaApplication-main-l-item" :class="{'activetxtindex3':n === activetxtindex}"  v-for="(item,n) in cloums3" @mouseenter="mouseenteractive(n)" @mouseleave="mouseleaveactive">
									{{item}}
								</div>
							</div>
						</div>
					</div>
					
				</div>
				
			</div>
			<div class="rpaxgal">
				<div class="container tab-block">
					<div class='fs-1 fw-bold text-center lyd-title-colo1' data-aos="fade-up">相关案例</div>
					<div class="SuccessCases_card">
					  <!-- <ListCard :demo-pages="demoPages" :demo-class="demoClass"></ListCard> -->
						<ListCard class="d-block d-lg-none" :type="2" :demo-pages="demoPages" :demo-class="demoClass"></ListCard>
          	<ListCard class="d-none d-lg-block" :demo-pages="demoPages" :demo-class="demoClass"></ListCard>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
	import Layout from '../components/common/Layout'
	import StaticBanner from "@/components/common/staticBanner/index.vue"
	import vueSeamlessScroll from 'vue-seamless-scroll'
	
	import ListCard from "@/components/common/relatedCases/listCard"
	
	export default {
		name: 'TabPage',
		components: { Layout, StaticBanner ,vueSeamlessScroll,ListCard},
		data() {
			return {
				activetxtindex:null,
				cloums1: [
					'5*8小时',
					'纸质回单、粘贴回单',
					'97%',
					'95%',
					'7天',
					'1-2分钟/张',
					'一家银行回单及对账单',
				],
				cloums2: [
					'工作时间',
					'无纸化程度（特定场景）',
					'业务办理精确度',
					'凭证自动化率',
					'集团结账周期',
					'发票全流程处理',
					'银行同步性',
				],
				cloums3: [
					'7*24小时',
					'无纸质回单、无需粘贴回单',
					'99.1%',
					'99%',
					'2-3天',
					'300张/1-2分钟',
					'全自动同步多银行回单及对账单',
				],
				demoPages: [
				  {
				    url: "/success-detail/1",
				    image: require("@/assets/images/casesimg/guolv-new.png"),
				    imageLight: require("@/assets/images/casesimg/guolv-new.png"),
				    title: "中国国旅",
				    content: "全球化财务共享中心管理",
				  },
				  {
				    url: "/success-detail/2",
				    image: require("@/assets/images/casesimg/botian-new.png"),
				    imageLight: require("@/assets/images/casesimg/botian-new.png"),
				    title: "博天环境 ",
				    content: "智慧业财新共享平台",
				  },
				  {
				    url: "/success-detail/3",
				    image: require("@/assets/images/casesimg/shanghai-baoye.png"),
				    imageLight: require("@/assets/images/casesimg/shanghai-baoye.png"),
				    title: "上海宝冶",
				    content: "打造一流的最具竞争优势核心理念",
				  },
					{
						url: "/success-detail/7",
						image: require("@/assets/images/casesimg/jiaotong.png"),
						imageLight: require("@/assets/images/casesimg/jiaotong.png"),
						title: "中冶交通",
						content: "智能业财管理助力财务管控更高效",
					}
				],
				demoClass:'col-lg-3 col-md-6 col-12',
				rpacjallmoblie1:[{
					label1:'票据识别',
					label2:'自动填报',
					url: require("@/assets/images/tab/rpacj1.png"),
					icon:require("@/assets/images/tab/rpacjbot.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'系统智能',
					label2:'规则控制',
					url: require("@/assets/images/tab/rpacj2.png"),
					icon:require("@/assets/images/tab/rpacjtop.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'网银机器人',
					url: require("@/assets/images/tab/rpacj3.png"),
					icon:require("@/assets/images/tab/rpacjbot.png"),
					anclass:'',
					anclass2:'',
				}],
				rpacjallmoblie2:[{
					label1:'智能申报',
					url: require("@/assets/images/tab/rpacj6.png"),
					icon:require("@/assets/images/tab/rpacjtop.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'智能监控',
					url: require("@/assets/images/tab/rpacj5.png"),
					icon:require("@/assets/images/tab/rpacjbot.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'智能开票',
					url: require("@/assets/images/tab/rpacj4.png"),
					icon:require("@/assets/images/tab/rpacjtop.png"),
					anclass:'',
					anclass2:'',
				}],
				rpacjall:[{
					label1:'票据识别',
					label2:'自动填报',
					url: require("@/assets/images/tab/rpacj1.png"),
					icon:require("@/assets/images/tab/rpacjbot.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'系统智能',
					label2:'规则控制',
					url: require("@/assets/images/tab/rpacj2.png"),
					icon:require("@/assets/images/tab/rpacjtop.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'网银机器人',
					url: require("@/assets/images/tab/rpacj3.png"),
					icon:require("@/assets/images/tab/rpacjbot.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'智能开票',
					url: require("@/assets/images/tab/rpacj4.png"),
					icon:require("@/assets/images/tab/rpacjtop.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'智能监控',
					url: require("@/assets/images/tab/rpacj5.png"),
					icon:require("@/assets/images/tab/rpacjbot.png"),
					anclass:'',
					anclass2:'',
				},{
					label1:'智能申报',
					url: require("@/assets/images/tab/rpacj6.png"),
					icon:require("@/assets/images/tab/rpacjtop.png"),
					anclass:'',
					anclass2:'',
				}],
				data1:['AI服务','今天天气如何？','路况拥堵状况','今天推荐吃什么?'],
				data2:['我要开票','给我讲解下多核算体系','什么是智能申报?','我要对账'],
				data3:['我要查询**月份对账单据','我要详尽的业务检查与报告','我要生成**月份业务凭证'],
				bannerDate: {
					url: require("@/assets/images/tab/rpa-bg.png"),
					title: "智能技术RPA",
					content: "AI+RPA融合、决策分析智能化、业务流程自动化",
					btn: true,
				},
			}
		},
		computed: {
			defaultOption () {
				return {
					step: 0.3, // 数值越大速度滚动越快
					limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 3, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			},
			defaultOption1 () {
				return {
					step: 0.2, // 数值越大速度滚动越快
					limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 3, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			},
			defaultOption2 () {
				return {
					step: 0.6, // 数值越大速度滚动越快
					limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 3, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			},
		},
		methods:{
			mouseleaveactive(){
				this.activetxtindex = null
			},
			mouseenteractive(index){
				this.activetxtindex = null
				this.activetxtindex = index
				
			},
			mouseenter(item,index){
				this.rpacjall.map((val)=>{
					val.anclass = ''
					val.anclass2 = ''
				})
				// item.anclass = 'animate__flipInY'
				item.anclass = 'animate__pulse'
				item.anclass2 = 'animate__fadeInUp'
			},
			goRouter(){
      this.$router.push({
        path:"/call-us"
      })
    }
		}
	}
</script>
<style lang="scss">

</style>
